import clsx from 'clsx';
import Store from './Store';
import * as React from 'react';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../../../../Translations';
import { activeSpanClassName, activeTabClassName } from './Types';
import { emptyFragment } from '../../../../../../../../../../../../EmptyFragment';

export interface Props {
  store: Store;
}

const Heading: React.FC<Props> = ({ store }) => {
  return (
    <div className="border-b border-gray-200 px-11 text-center text-sm text-gray-500">
      <ul className="-mb-px flex flex-wrap">
        {fromEmpty(store.resource.payload.experiences)
          .map((experiences) => (
            <li>
              <p
                className={clsx(
                  activeTabClassName(store.state, 'programs'),
                  'inline-block rounded-t-lg border-b-2 py-4 pr-4 hover:border-gray-300',
                  'cursor-pointer text-lg hover:text-gray-600',
                )}
                onClick={() => store.updateTab('programs')}
                data-intercom-target="programs-tab"
              >
                <T kind="Programs" />
                <span
                  className={clsx(
                    activeSpanClassName(store.state, 'programs'),
                    'ml-2 rounded-full px-2 py-1 text-sm text-white',
                  )}
                >
                  {experiences.length}
                </span>
              </p>
            </li>
          ))
          .getOrElse(emptyFragment)}

        {fromEmpty(store.resource.payload.schoolPartners)
          .map((schoolPartners) => (
            <li className="mr-2">
              <p
                className={clsx(
                  activeTabClassName(store.state, 'schoolPartners'),
                  'inline-block cursor-pointer rounded-t-lg border-b-2 p-4 text-lg font-medium',
                )}
                onClick={() => store.updateTab('schoolPartners')}
                data-intercom-target="school-partners-tab"
              >
                <T kind="School Partners" />
                <span
                  className={clsx(
                    activeSpanClassName(store.state, 'schoolPartners'),
                    'ml-2 rounded-full px-2 py-1 text-sm text-white',
                  )}
                >
                  {schoolPartners.length}
                </span>
              </p>
            </li>
          ))
          .getOrElse(emptyFragment)}

        {fromEmpty(store.resource.payload.competencies)
          .map((competencies) => (
            <li className="mr-2">
              <p
                className={clsx(
                  activeTabClassName(store.state, 'competencies'),
                  'inline-block cursor-pointer rounded-t-lg border-b-2 p-4 text-lg font-medium',
                )}
                onClick={() => store.updateTab('competencies')}
                data-intercom-target="competencies-tab"
              >
                <T kind="Competencies" />
                <span
                  className={clsx(
                    activeSpanClassName(store.state, 'competencies'),
                    'ml-2 rounded-full px-2 py-1 text-sm text-white',
                  )}
                >
                  {competencies.length}
                </span>
              </p>
            </li>
          ))
          .getOrElse(emptyFragment)}
      </ul>
    </div>
  );
};

export default observer(Heading);
